import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const I18nContext = createContext(null);
export const LANGS = [
  { code: "en", label: "EN" },
  { code: "pl", label: "PL" },
  { code: "uk", label: "UK" },
  { code: "ro", label: "RO" },
];

export function I18nProvider({ children }) {
  const { user } = useAuth();
  const [locale, setLocale] = useState(localStorage.getItem("iclean_locale") || "en");
  const [strings, setStrings] = useState({});

  const load = useCallback(async (loc) => {
    try {
      const { data } = await client.get(`/meta/i18n/${loc}`);
      setStrings(data.strings || {});
    } catch {
      setStrings({});
    }
  }, []);

  useEffect(() => {
    if (user && user.languagePref && !localStorage.getItem("iclean_locale")) {
      setLocale(user.languagePref);
    }
  }, [user]);

  useEffect(() => {
    load(locale);
    localStorage.setItem("iclean_locale", locale);
  }, [locale, load]);

  const t = (key, fallback) => strings[key] || fallback || key;

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
